/**
 * Determina la variante del badge según el porcentaje de matching
 * @param {number} porcentaje - Porcentaje de matching (0-100)
 * @returns {Object} Objeto con variant, label, percentageValue y darkerBgClass para el Badge
 */
export const getBadgeVariantByPercentage = (porcentaje = 0) => {
    if (porcentaje === 100) {
        return {
            variant: 'success',
            label: 'Coincidencia',
            percentageValue: '100%',
            darkerBgClass: 'bg-[#1D6E2A]'
        };
    } else if (porcentaje >= 80.01 && porcentaje <= 99.99) {
        return {
            variant: 'warning',
            label: 'Coincidencia',
            percentageValue: `${porcentaje}%`,
            darkerBgClass: 'bg-warning-0'
        };
    } else {
        return {
            variant: 'error',
            label: 'Coincidencia',
            percentageValue: `${porcentaje}%`,
            darkerBgClass: 'bg-error-10'
        };
    }
};
